export const FeatureGamePage = {
  LabelSponsoredAd: 'Label.SponsoredAd',
  LabelNoSearchResults: 'LabelNoSearchResults',
  LabelPlayingOnePlusUsersWithComma: 'LabelPlayingOnePlusUsersWithComma',
  LabelPlayingOneUser: 'LabelPlayingOneUser'
};

export const CommonGameSorts = {
  LabelApiError: 'Label.ApiError',
  LabelGames: 'Label.Games'
};

export const FeaturePlacesList = {
  ActionSeeAll: 'Action.SeeAll',
  LabelGenreExplorerName: 'Label.GenreExplorerName'
};

export const FeatureGameDetails = {
  HeadingDescription: 'Heading.Description',
  LabelPlaying: 'Label.Playing',
  LabelFavorites: 'Label.Favorites',
  LabelVisits: 'Label.Visits',
  LabelCreated: 'Label.Created',
  LabelUpdated: 'Label.Updated',
  LabelMaxPlayers: 'Label.MaxPlayers',
  LabelGenre: 'Label.Genre',
  LabelAllowedGear: 'Label.AllowedGear',
  LabelReportAbuse: 'Label.ReportAbuse',
  LabelPlaceCopyingAllowed: 'Label.PlaceCopyingAllowed'
};

export const FeatureGearOptionsDisplay = {
  LabelAllGenreAllowed: 'LabelAllGenreAllowed',
  LabelGearOnly: 'LabelGearOnly',
  LabelNoGear: 'LabelNoGear'
};

export default {
  CommonGameSorts,
  FeatureGamePage,
  FeaturePlacesList,
  FeatureGameDetails,
  FeatureGearOptionsDisplay
};
